export default "__VITE_ASSET__BULJopDb__"